import { contieneCaracteresPeligrosos, isValidEmail, validarLongitudMaxima, validarSoloNumeros, normalizeEmail } from "../../../utils/validacionesForms";


export const runValidateFieldsSignUp = (formSignup, setErrors) => {

    const newErrors = {};
    let hasValidate = true;

    const maxDocumentLength = 10;
    const maxPhoneLength = 10;

    if (formSignup.typeDocument === "0" || formSignup.typeDocument === 0 || formSignup.typeDocument === "") {
        newErrors.typeDocument = "Selecciona una opción válida.";
    }
    if (formSignup.document.length <= 0 || formSignup.document === "") {
        newErrors.document = "Documento inválido.";
    }
    if (formSignup.email.length <= 0 || formSignup.email === "") {
        newErrors.email = "Ingrese un correo electrónico válido.";
    }
    const normalizedEmail = normalizeEmail(formSignup.email);
    if (normalizedEmail !== formSignup.email) {
        newErrors.email = "El correo contiene caracteres inválidos que deben ser removidos.";
    }
    if (!validarSoloNumeros(formSignup.document)) {
        newErrors.document = "Documento inválido.";
    }
    if (!isValidEmail(normalizedEmail || formSignup.email)) {
        newErrors.email = "El correo que ingresaste no es válido.";
    }
    if (!validarSoloNumeros(formSignup.phone)) {
        newErrors.phone = "El número de telefono ingresado no es válido, asegurate de ingresar sólo números";
    }
    if (formSignup.phone.length !== 10) {
        newErrors.phone = "Tu número de teléfono no es válido, por favor verifícalo";
    }
    if (!formSignup.terms) {
        newErrors.terms = "Debes aceptar los terminos y condiciones para continuar";
    }
    if (!formSignup.policyData) {
        newErrors.policyData = "Debes autorizar la política de tratamiento de datos para continuar";
    }

    // Validar Longitud y caracteres para documento y teléfono
    if (!validarLongitudMaxima(formSignup.document, maxDocumentLength) || contieneCaracteresPeligrosos(formSignup.document)) {
        newErrors.document = "Documento inválido.";
    }

    if (!validarLongitudMaxima(formSignup.phone, maxPhoneLength) || contieneCaracteresPeligrosos(formSignup.phone)) {
        newErrors.phone = "Teléfono inválido.";
    }

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        hasValidate = false;
    } else {
        setErrors({});
    }
    return hasValidate;

}